import storage from "../../utils/storage"
import { EmailUser } from "../../api/user"
import { DigiAuthUser, User } from "../../types/user";
import { navigateTo } from "../../utils/navigation";

const emailFormKey = "passwordForm"
const digiAuthFormKey = "digiAuthForm";

export const getSavedEmailValues = () => storage.get<EmailUser>(emailFormKey)

export const getSavedDigiAuthValues = () => storage.get<DigiAuthUser>(digiAuthFormKey);

export const saveEmailValues = (values: EmailUser): void => {
  storage.set(emailFormKey, {...values, password: ""})
}

export const saveDigiAuthValues = (values: DigiAuthUser): void => {
  storage.set(digiAuthFormKey, values)
}

export const navigateToNextStep = () => {
  if (App.returnTo) {
    document.location.assign(App.returnTo);
    return;
  }

  const user = App.user as User;
  let path = "";
  if (user.role === "business_borrower") {
    path = "loans/new/personal";
  } else {
    if (user.role === "investor") {
      if (user.registrationCompleted) {
        path = "investment";
      } else {
        path = "investors/new";
      }
    }
  }

  if (user.role === "customer_service") {
    navigateTo("/backend");
  } else {
    navigateTo(`/${user.locale}/${path}`);
  }
}
